<template>
  <div>
    <div class="card mb-3">
      <div class="card-body py-3">
        <form @submit.prevent="loadReport()">
          <div class="row align-items-end">
            <div class="col">
              <label class="font-size-13 font-weight-medium mb-1 text-muted">Tipo de Relatório</label>
              <div v-if="loadingTypes" class="d-flex align-items-center py-2">
                <div class="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
                <span class="text-muted font-size-13">Carregando tipos disponíveis...</span>
              </div>
              <select
                v-else
                class="custom-select"
                v-model="report.type"
              >
                <option value="" disabled>Selecione um relatório</option>
                <option
                  v-for="type in availableTypes"
                  :key="type.key"
                  :value="type.key"
                >
                  {{ type.label }}
                </option>
              </select>
            </div>
            <div class="col-auto">
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="!report.type || loadingTypes"
              >
                <i class="bx bx-bar-chart-alt-2 mr-1"></i>
                Carregar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { getAvailableTypes } from './services'

export default {
  name: 'reports-header',
  data () {
    return {
      loadingTypes: true,
      availableTypes: [],
      report: {
        type: ''
      }
    }
  },
  mounted () {
    this.fetchAvailableTypes()
  },
  methods: {
    async fetchAvailableTypes () {
      this.loadingTypes = true
      try {
        const res = await getAvailableTypes()
        this.availableTypes = res.data || []

        // Auto-seleciona o tipo atual pela rota (sem navegar)
        const currentRoute = this.$route.name || ''
        const currentType = currentRoute.replace('report-', '')
        const match = this.availableTypes.find(t => t.key === currentType)

        if (match) {
          this.report.type = match.key
        } else if (this.availableTypes.length > 0) {
          this.report.type = this.availableTypes[0].key
          this.loadReport()
        }
      } catch (err) {
        console.error('Falha ao carregar tipos de relatório', err)
      } finally {
        this.loadingTypes = false
      }
    },
    loadReport () {
      if (!this.report.type) return
      const name = `report-${this.report.type}`
      if (this.$route.name !== name) {
        this.$router.push({ name })
      }
    }
  }
}
</script>
